import type { Theme } from '../hooks/useTheme';

interface ThemeToggleProps {
  theme: Theme;
  onChange: (theme: Theme) => void;
}

const themes: { value: Theme; icon: string; label: string }[] = [
  { value: 'light', icon: '\u2600\uFE0F', label: 'Light' },
  { value: 'dark', icon: '\uD83C\uDF19', label: 'Dark' },
  { value: 'system', icon: '\uD83D\uDCBB', label: 'System' },
];

export function ThemeToggle({ theme, onChange }: ThemeToggleProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-1 rounded-lg bg-telegram-secondary-bg p-1 dark:bg-telegram-secondary-bg-dark">
      {themes.map(({ value, icon, label }) => (
        <button
          key={value}
          onClick={() => onChange(value)}
          className={`rounded-md px-2 py-1 text-sm transition-colors ${
            theme === value
              ? 'bg-white text-telegram-text shadow dark:bg-telegram-bg-dark dark:text-telegram-text-dark'
              : 'text-telegram-text-secondary hover:text-telegram-text dark:text-telegram-text-secondary-dark dark:hover:text-telegram-text-dark'
          }`}
          title={label}
        >
          {icon}
        </button>
      ))}
    </div>
  );
}
